export interface ITee {
  distance: number;
  gender: 'M' | 'F';
  id: number;
  name: string;
  par: number;
  rating: string;
  slope: number;
}

export interface ICourse {
  id: number;
  name: string;
  address: string;
  tees?: ITee[];
}

export const adminCoursesStore: ICourse[] = [];
